import React, { useState, useMemo } from 'react';
import { PopupModal } from 'react-calendly';
import "./Contacto.scss";

export default function Contacto() {
  const [isCalendlyOpen, setIsCalendlyOpen] = useState(false);

  // Tu link de Calendly (30 min)
  const calendlyUrl = useMemo(
    () => "https://calendly.com/ventas-norluxaberturas/30min",
    []
  );

  const openCalendly = () => {
    setIsCalendlyOpen(true);
    // opcional: bloquear scroll mientras el modal está abierto
    document.body.style.overflow = "hidden";
  };

  const closeCalendly = () => {
    setIsCalendlyOpen(false);
    document.body.style.overflow = "";
  };

  return (
    <div className='contacto'>
      <h1 className='section-title' style={{color: "white"}}>
        ¿Listo para transformar <b style={{color: "var(--color-2)"}}>tu proyecto?</b>
      </h1>

      <p className='section-subtitle' style={{color: "white"}}>
        Obtén un presupuesto personalizado o agenda una reunión con nuestros especialistas. Te acompañamos en cada paso del proceso.
      </p>

      <div className='resaltador'>
        <span className='linea' style={{backgroundColor: "white"}}></span>
      </div>

      <div className='row g-5'>
        <div className='col-lg-6'>
          <div className='presupuesto'>
            <div className='d-flex justify-content-center mb-3'>
              <span className='icon-container'>
                <i className="bi bi-chat-left-dots"></i>
              </span>
            </div>
            <p className='title'>Solicitar Presupuesto</p>
            <p className='description'>Recibe una cotización detallada sin compromiso</p>
            <a href='/contacto' className='btn-presupuesto'>Obtener Presupuesto Gratuito</a>
            <ul>
              <li>
                <span className='circle'></span>
                <p>Respuesta en menos de 24 horas.</p>
              </li>
              <li>
                <span className='circle'></span>
                <p>Consultar por visita técnica gratis.</p>
              </li>
              <li>
                <span className='circle'></span>
                <p>Sin compromiso de compra.</p>
              </li>
            </ul>
          </div>
        </div>

        <div className='col-lg-6'>
          <div className='reunion presupuesto'>
            <div className='d-flex justify-content-center mb-3'>
              <span className='icon-container'>
                <i className="bi bi-calendar-check"></i>
              </span>
            </div>
            <p className='title'>Agendar Reunión</p>
            <p className='description'>Habla directamente con nuestros especialistas</p>

            {/* Botón que abre Calendly */}
            <button
              type="button"
              className='btn-presupuesto'
              onClick={openCalendly}
            >
              Reservar Cita Online
            </button>

            <ul>
              <li>
                <span className='circle'></span>
                <p>Reuniones virtuales o presenciales</p>
              </li>
              <li>
                <span className='circle'></span>
                <p>Asesoramiento técnico especializado</p>
              </li>
              <li>
                <span className='circle'></span>
                <p>Horarios flexibles</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className='anexo'>
        <p className='main-text'>¿Prefieres contactarnos directamente?</p>
        <div className='d-flex justify-content-lg-center justify-content-around align-items-center'>
          <span className='d-flex me-0 me-lg-5'>
            <i className="bi bi-telephone-fill me-2"></i>
            <p className='mb-0'>+54 11 3427-0100</p>
          </span>
          <span className='d-flex align-items-center'>
            <i className="bi bi-envelope me-2"></i>
            <p className='mb-0'>ventas@norluxaberturas.com</p>
          </span>
        </div>
      </div>

      {/* Calendly Popup (se renderiza acá para no tocar tu diseño) */}
      <PopupModal
        url={calendlyUrl}
        open={isCalendlyOpen}
        onModalClose={closeCalendly}
        /*
          IMPORTANTE:
          - En CRA: rootElement suele ser document.getElementById("root")
          - Si tu app tiene otro id, ajustalo.
        */
        rootElement={document.getElementById("root")}
      />
    </div>
  );
}
